import routerDev from './router/lazy'
import routerPro from './router/lazy_pro'
import { getToken, setToken } from '@/utils/localstorage' // 存储本数据
//白名單
const whiteList = ['登录页']
// 判断 环境是否满足
let router = routerPro
if (process.env.NODE_ENV === 'development') {
  router = routerDev
}
// 使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {
  console.log('to', to)
  if (to.query.webToken) {
    setToken('webToken', to.query.webToken)
    // setToken('resourceList', JSON.parse(to.query.resourceList))
    router.push(to.path)
  }
  if (getToken('webToken')) {
    if (to.name == '首页面' || to.name == '登录页') {
      return next()
    } else {
      switch (to.matched[1].name) {
        case '核算组':
          router.options.routes[2].children.forEach((v, i) => {
            if (v.name != '核算组') {
              v.invisible = true
            } else {
              v.invisible = false
            }
          })
          next()
          break
        case '税务组':
          router.options.routes[2].children.forEach((v, i) => {
            if (v.name != '税务组') {
              v.invisible = true
            } else {
              v.invisible = false
            }
          })
          next()
          break
        case '基础设置':
          router.options.routes[2].children.forEach((v, i) => {
            if (v.name != '基础设置') {
              v.invisible = true
            } else {
              v.invisible = false
            }
          })
          next()
          break
        case '开票中心':
          router.options.routes[2].children.forEach((v, i) => {
            if (v.name != '开票中心') {
              v.invisible = true
            } else {
              v.invisible = false
            }
          })
          next()
          break
        // case '运营看板':
        //   router.options.routes[2].children.forEach((v, i) => {
        //     if (v.name != '运营看板') {
        //       v.invisible = true;
        //     } else {
        //       v.invisible = false;
        //     }
        //   })
        //   next();
        //   break
        case '小工具':
          router.options.routes[2].children.forEach((v, i) => {
            if (v.name != '小工具') {
              v.invisible = true
            } else {
              v.invisible = false
            }
          })
          next()
          break
        case '费用中心':
          router.options.routes[2].children.forEach((v, i) => {
            if (v.name != '费用中心') {
              v.invisible = true
            } else {
              v.invisible = false
            }
          })
          next()
          break
      }
    }
  } else {
    if (whiteList.includes(to.name)) {
      // 在免登录白名单，直接进入
      return next()
    } else {
      next({
        path: '/login',
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/permission.js